export const moreFromPocketClick = {
  name: 'Clicked Recommendation',
  category: 'Storypage',
  nonInteraction: true,
  label: 'Bottom'
}

export const moreFromPocketScroll = {
  name: 'Viewed Recommendation',
  category: 'Storypage',
  nonInteraction: true,
  label: 'Bottom'
}

export const publisherRecircClick = {
  name: 'Clicked Recommendation',
  category: 'Storypage',
  nonInteraction: true,
  label: 'Right Rail'
}

export const publisherRecircScroll = {
  name: 'Viewed Recommendation',
  category: 'Storypage',
  nonInteraction: true,
  label: 'Right Rail'
}

export const publisherCtaClick = {
  name: 'Clicked Publisher CTA',
  category: 'Storypage',
  nonInteraction: true
}

export const publisherCtaScroll = {
  name: 'Viewed Publisher CTA',
  category: 'Storypage',
  nonInteraction: true
}

export const scrollDepthEvent = {
  name: 'Scrolled Page',
  category: 'Storypage',
  nonInteraction: true,
}
